import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const usersRoutesDictionary = moduleRouteDictionaryFactory(
  'users',
  'users',
  {
    list: 'list',
    detail: 'detail/:userId',
    editAnagraphic: 'edit/:userId/anagraphic',
    userErrors: 'detail/:userId/errors',
    employee: ':userId/employee/:employeeId',
    hr: ':userId/hr/:hrId',
  },
);
